import { create } from "zustand";

const INITIAL_STATE = {
  isActive: false,
  peekHandleKey: "",
  modalContentKey: "",
  modalContentProps: {},
  peekHandleProps: {},
};

export const usePeekHandleStore = create((set) => ({
  ...INITIAL_STATE,

  open: (peekHandleKey, modalContentKey, modalContentProps, peekHandleProps) =>
    set({
      isActive: true,
      peekHandleKey,
      modalContentKey,
      modalContentProps,
      peekHandleProps,
    }),

  close: () => set(INITIAL_STATE),
}));
